import script from "./detail-fault-analysis.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail-fault-analysis.vue?vue&type=script&lang=ts&setup=true"

import "./detail-fault-analysis.vue?vue&type=style&index=0&id=19f86e99&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f86e99"]])

export default __exports__